import React from 'react';
import SearchComponent from '../../common/search';

const SearchItemArea = ({
	slug,
	handleSearch,
	defaultSearchValues = [],
	defaultSearchItems = [],
	btnName = '',
	getActiveFieldIds,
	showFilterBtn = true,
	extraConditions,
	searchRef,
}) => {
	return (
		<>
			{slug && (
				<SearchComponent
					ref={searchRef}
					slug={slug}
					callFrom="external"
					setQuery={handleSearch}
					btnName={btnName}
					defaultSearchItems={defaultSearchItems}
					defaultSearchValues={defaultSearchValues}
					getActiveFieldIds={getActiveFieldIds}
					extraConditions={extraConditions}
					showFilterBtn={showFilterBtn}
				/>
			)}
		</>
	);
};

export default SearchItemArea;
